

import router from "@/router";

declare global {
  interface Window {
    Marzipano: any;
  }
}

import {computed, defineComponent, ref, watch, onMounted} from 'vue';
import {useRoute} from "vue-router";
import Config from '@/config'
import Pano from '@/types/Pano'
import Hotspot from '@/types/Hotspot'
import AdminPano from '@/components/AdminPano.vue'
import getAdmin from '@/composables/getAdmin'
import getRoom from "@/composables/getRoom";
import Navigation from "@/components/Navigation.vue";
import Modal from "@/components/Modal.vue";
import Audio from "@/components/Audio.vue"
import { useUserStore } from "@/store/useUserStore"
import updateGame from "@/composables/updateGame";
import setPresenceState from "@/composables/setPresenceState";

export default defineComponent({
  name: 'Room',
  inheritAttrs: false,
  components: {
    Navigation,
    AdminPano,
    Modal,
    Audio
  },
  props: {
    playerId: {
      type: String,
      default: '',
      required: true
    },
    playerName: {
      type: String,
      default: '',
      required: true
    },
    uid: {
      type: String,
      default: '',
      required: false
    }
  },

  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate", to, from, next)
    let times = to.meta.times as Record<string, Record<string, any>> || {}
    const roomId = to.params.room[0] || to.params.room
    // const playerId = to.params.playerId
    const uid = to.params.uid as string
    const maxRooms = to.params.projectMaxRooms as string


    console.log("beforeRouteUpdate: maxRooms", maxRooms)
    // if roomsId higher maxRoom or uid does not exist: go Home
    if ((maxRooms && +roomId > +maxRooms) || !uid) {
      next({replace: true, name: 'Start', params: {id: to.params.id, lang: to.params.lang}})
      return
    }

    if (roomId) {
      if (uid) {
        let updateTimeObj = {}
        // if the statingTime for the room has not been set yet
        if (!Object.keys(times).length || times[+roomId]?.startingTime === undefined || times[+roomId]?.startingTime === null) {
          updateTimeObj = {times: {[+roomId]: {user: {[uid]: new Date()}, startingTime: new Date()}}}
        } else {
          // otherwise add just the user with timestamp
          updateTimeObj = {times: {[+roomId]: {user: {[uid]: new Date()}}}}
        }
        console.log('updateTimeObj beforeRouteUpdate', updateTimeObj)
        const { updateGame: updateDoc } = updateGame('games')
        updateDoc(to.params.id.toString(), updateTimeObj)

        // got to room
        next()
      } else {
        // if not: go Home
        next({replace: true, name: 'Start', params: {id: to.params.id, lang: to.params.lang}})
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    let progress = to.meta.projectProgress as Record<number, string> || {}
    let times = to.meta.times as Record<string, Record<string, any>> || {}
    const maxRooms = to.meta.projectMaxRooms as number
    const roomId = to.params.room[0] || to.params.room
    const playerName = to.params.playerName
    const playerId = to.params.playerId
    const uid = to.params.uid as string
    const lang = to.params.lang
    const id = to.params.id

    // if uid not exist: go Home
    if (!uid) {
      next({replace: true, name: 'Start', params: {id, lang: to.params.lang}})
      return
    }

    // enter new or first room
    if (!progress || !progress[+roomId]) {
      progress = {...progress, [`${roomId}`]: false}
      if (progress[+roomId - 1] || roomId === '1') {
        const { updateGame: updateDoc } = updateGame('games')
        updateDoc(to.params.id.toString(), {progress: progress})
      }
    }
    // check if room has been finished
    if (progress[+roomId]) {

      // if true check if all rooms have been finished => go to End
      if (+roomId >= maxRooms) {
        next({replace: true, name: 'End', params: {id, playerName, playerId, lang, uid}})
      }
      // if true: try next room
      const nextRoom = +roomId + 1
      next({replace: true, name: 'Room', params: {id, room: nextRoom, playerName, playerId, lang, uid, maxRooms}})
    } else {
      // if false: check if last room has been finished
      if (roomId !== '1' && !progress[+roomId - 1]) {
        // if not: go Home
        next({replace: true, name: 'Start', params: {id, lang: to.params.lang}})
      } else {
        let updateTimeObj = {}
        // if the statingTime for the room has not been set yet
        if (!Object.keys(times).length || times[+roomId]?.startingTime === undefined || times[+roomId]?.startingTime === null ) {
          updateTimeObj = {times: {[+roomId]: {user: {[uid]: new Date()}, startingTime: new Date()}}}
        } else {
          // otherwise add just the user with timestamp
          updateTimeObj = {times: {[+roomId]: {user: {[uid]: new Date()}}}}
        }
        console.log('updateTimeObj', updateTimeObj)
        const { updateGame: updateDoc } = updateGame('games')
        updateDoc(to.params.id.toString(), updateTimeObj)
        // got to room
        next()
      }
    }
  },
  setup: function (props) {
    const userStore = useUserStore()
    const isMobile = (userStore.isMobile === 'true')
    const route = useRoute()
    const config = Config
    const playerNames = config.player.map(item => item.name)
    const id = route.params.id
    const room = route.params.room
    const projectName = config.project
    const viewRef = ref(null)
    const viewerRef = ref(null)
    let viewer: any = null
    let scenes: any = []
    const hotspotArrRef = ref<Hotspot[]>([])
    const playerIdRef = ref<number>(parseInt(props.playerId))
    const playerNameRef = ref<string>(props.playerName)
    const uidRef = ref<string>(props.uid)
    const local = ref<boolean>(window.document.location.hostname === '192.168.178.32'  || window.document.location.hostname === 'localhost')

    // modal vars
    const closeNav = ref<boolean>(false)
    const modalContent = ref<string | null>(null)
    const modalLink = ref<string>()
    const modalSolutionChat = ref<string>('')
    const modalSolutionQuestion = ref<string>('')
    const modalTimestamp = ref<string>('')
    const audio = ref<string>('')
    const playAudio = ref(0)

    if (!props.playerId) {
      router.push({name: 'Start'})
      return
    }
    console.log("setPresenceState", id.toString(), playerIdRef.value, +room, uidRef.value)
    setPresenceState(id.toString(), playerIdRef.value, +room, uidRef.value)


    // check if user is logged in for administration
    const { admin } = getAdmin()

    const {
      error: errorRoom,
      documents: roomDocsRef,
      load: loadPano
    } = getRoom(`projects/${projectName}/rooms/`, "room", +room)
    loadPano()


    // Viewer options.
    const viewerOpts = {
      "settings": {
        "mouseViewMode": "drag",
        "autorotateEnabled": true,
        "fullscreenButton": true,
        "viewControlButtons": true
      }
    }

    const Marzipano = computed(() => {
      return window.Marzipano || {}
    })

    onMounted(() => {
      const panoElement = document.getElementById('pano');

      // Initialize viewer
      viewer = new Marzipano.value.Viewer(panoElement, viewerOpts);
      viewerRef.value = viewer
    })


    watch(roomDocsRef, () => {
      console.log("Error Room:", errorRoom.value)
      if (!errorRoom.value) {
        console.log("roomDocs.value", Object.assign({}, roomDocsRef))
        console.log("roomDocs", roomDocsRef.value)
        if (!roomDocsRef.value) {
          console.log("Error: Pano could not be loaded.")
          return
        }

        const roomData = JSON.parse(JSON.stringify(roomDocsRef.value))[0] // ['player' + props.player]
        console.log("roomData", roomData)

        // reset Array Hotspots
        hotspotArrRef.value.length = 0

        // Create scenes.
        scenes = roomData.panos.map((data: Pano, playerId: number) => {

          // load only relevant pano - except if user is locked in admin
          if ( playerId !== playerIdRef.value && !admin.value && !local.value) return

          // Create source.
          const source = (isMobile) ? Marzipano.value.ImageUrlSource.fromString(data.urlMobile) : Marzipano.value.ImageUrlSource.fromString(data.url)

          // Create geometry.
          const geoWidth = (isMobile) ? [{width: 2560}] : [{width: 5120}]
          const geometry = new Marzipano.value.EquirectGeometry(geoWidth)

          const initialView = {
            yaw: data.yaw * Math.PI / 180,
            pitch: data.pitch * Math.PI / 180,
            fov: 120 * Math.PI / 180
          };

          const limiter = Marzipano.value.util.compose(
              Marzipano.value.RectilinearView.limit.traditional(1024, 100 * Math.PI / 180),
              Marzipano.value.RectilinearView.limit.pitch(data.pitchRange.min, data.pitchRange.max),
          )

          // Create view.
          // const limiter = Marzipano.value.RectilinearView.limit.traditional(1024, 100 * Math.PI / 180)
          const view = new Marzipano.value.RectilinearView(initialView, limiter)

          // Create scene.
          const scene = viewer.createScene({
            source: source,
            geometry: geometry,
            view: view,
            pinFirstLevel: true
          })

          // const {error, documents: hotspotsDoc, load: loadHotspots} = getHotspots(`projects/birthdayParty/rooms/${roomData.id}/hotspots`, "pano",  index + 1)
          // loadHotspots()

          if (data.hotspots) {
            data.hotspots.forEach((item: Hotspot, index) => {
              const hsDiv = document.createElement('div')
              hsDiv.classList.add('hotspot')
              hsDiv.classList.add('hs-' + item.type)
              hsDiv.style.width = (isMobile) ? "50px" : item.width + "px"
              hsDiv.style.height = (isMobile) ? "50px" : item.height + "px"
              hsDiv.textContent = item.name
              hsDiv.setAttribute('data-name', item.name)
              scene.hotspotContainer().createHotspot(hsDiv, {
                yaw: item.yaw,
                pitch: item.pitch,
              }, { perspective: {
                radius: 1000
              }
              });
              hsDiv.addEventListener('click', function () {
                updateModal(item.type, item.path, roomData.addressee, roomData.question, roomData.timestamp.seconds.toString())
              })
              hotspotArrRef.value.push({...item, playerId, id: index})
            })
          }

          return {
            scene: scene,
            view: view
          }
        })


        viewer.stage().addEventListener('renderComplete', function (eventName: string, complete: boolean) {
          console.log("Render Complete", eventName, complete)
        });


        // Display scene.
        console.log("SwitchTo", scenes[playerIdRef.value].scene)
        console.log("viewRef", scenes[playerIdRef.value].view)
        scenes[playerIdRef.value].scene.switchTo()
        viewRef.value = scenes[playerIdRef.value].view

        // Open phone on first room
        if (room === '1') {
          setTimeout(() => openModal('phone', 'chat-lisa-paul', roomData.addressee, '', roomData.timestamp.seconds.toString()), 2000)
        }
      }
    })

    watch(playerIdRef, () => {
      scenes[playerIdRef.value].scene.switchTo()
      viewRef.value = scenes[playerIdRef.value].view
      playerNameRef.value = playerNames[playerIdRef.value]
      userStore.playerId = playerIdRef.value.toString();
      userStore.playerName = playerNames[playerIdRef.value]
    })

    // open Modal
    const updateModal = (compName: string, path = '', solutionChat = '', solutionQuestion = '', timestamp = '') => {
      console.log('compName', compName)
      if (modalContent.value) {
        console.log("modalContent", modalContent.value)
        modalContent.value = null
        setTimeout(() => {
          openModal(compName, path, solutionChat, solutionQuestion, timestamp)
        }, 0)
      } else {
        openModal(compName, path, solutionChat, solutionQuestion, timestamp)
      }
    }

    const openModal = (compName: string, path = '', solutionChat = '', solutionQuestion = '', timestamp = '') => {
      console.log("compName", compName)
      console.log("solutionQuestion", solutionQuestion)
      switch (compName) {
        case "phone":
          modalContent.value = 'Phone'
          modalSolutionChat.value = solutionChat
          modalSolutionQuestion.value = solutionQuestion
          modalTimestamp.value = timestamp
          modalLink.value = path
          break
        case "image":
          modalContent.value = "Image"
          modalLink.value = path
          break;
        case "carousel":
          modalContent.value = "Carousel"
          modalLink.value = path
          break;
        case "audio":
          playAudio.value++
          audio.value = path
          break;
        case "component":
          modalContent.value = path
          break;
        case "browser":
          modalContent.value = "Browser"
          modalLink.value = path
          break;
        default:
          modalContent.value = compName
      }

      // close navigation when modal opens
      if(compName !== 'audio' && compName !== null && isMobile) {
        closeNav.value = !closeNav.value
      }
    }

    return {viewRef, viewerRef, playerNameRef, playerIdRef, hotspotArrRef, loadPano, admin, local, updateModal, closeNav, modalContent, modalLink, modalSolutionChat, modalSolutionQuestion, modalTimestamp, audio, playAudio}
  }
})
